export default "__VITE_ASSET__BxE3b5$m__"